import React from 'react';
import PropTypes from 'prop-types';
import { EmailIcon, PhoneIcon, ProfileIcon, LocationIcon } from '@domain-group/fe-co-icon';
import * as styles from '../../styles/homepass-booking/homepass-booking-structure';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ContactField = props => {
  var handleChange = event => {
    props.onValueChange(event);
  };
  var displayIcon = iconName => {
    if (iconName === 'email') {
      return ___EmotionJSX(EmailIcon, {
        size: "regular",
        css: styles.contactFormIcon
      });
    }
    if (iconName === 'phone') {
      return ___EmotionJSX(PhoneIcon, {
        size: "regular",
        css: styles.contactFormIcon
      });
    }
    if (iconName === 'postCode') {
      return ___EmotionJSX(LocationIcon, {
        size: "regular",
        css: styles.contactFormIcon
      });
    }
    return ___EmotionJSX(ProfileIcon, {
      size: "regular",
      css: styles.contactFormIcon
    });
  };
  return ___EmotionJSX("div", {
    css: styles.textFieldWrapper,
    "data-testid": "homepass-booking__text-field-wrapper"
  }, displayIcon(props.iconName), ___EmotionJSX("input", {
    type: "text",
    name: props.fieldName,
    placeholder: props.placeHolder,
    value: props.fieldValue,
    onChange: handleChange,
    css: styles.contactFormInput(props.fieldError)
  }), props.fieldError ? ___EmotionJSX("div", {
    css: styles.contactFormErrorMessage
  }, props.fieldError) : false);
};
ContactField.propTypes = {
  iconName: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  placeHolder: PropTypes.string,
  fieldValue: PropTypes.string,
  fieldError: PropTypes.string,
  onValueChange: PropTypes.func
};
ContactField.defaultProps = {
  placeHolder: '',
  fieldValue: '',
  fieldError: '',
  onValueChange: () => {}
};
export default ContactField;